import Amplify, {Auth} from "aws-amplify";

class AmplifyConfigurator {
    static init() {
        Amplify.configure({
            Auth: {
                identityPoolId: 'us-east-1:56dd7fc7-79f3-405a-8a37-ddbde70a6ea0',
                region: 'us-east-1',
                userPoolId: 'us-east-1_RnfbVFsSz',
                userPoolWebClientId: '3ssbmheafvr0d3dl3t7a1g1jqs',
                authenticationFlowType: "USER_PASSWORD_AUTH"
            },
            API: {
                endpoints: [
                    {
                        name: "BackOfficeAPI",
                        endpoint: "https://d1oqfilhf4ovog.cloudfront.net/api",
                        custom_header: async () => {
                            try {
                                const userData = await Auth.currentAuthenticatedUser();
                                if (userData && userData.attributes) {
                                    return {"x-access-token": userData.attributes['custom:backoffice-token']};
                                }
                            }
                            catch (error) {
                                return {};
                            }
                        }
                    }
                ]
            }
        });
    }
}

export default AmplifyConfigurator;

